import React from "react";
import loadable from "@loadable/component";
import CenterSpinner from "../../common/centerSpinner";

function AsyncBookingList({ ...rest }) {
  const AsyncLoad = loadable(() => import("../page/userBookingList"));
  console.log("Loading", AsyncBookingList.name);
  return <AsyncLoad {...rest} fallback={<CenterSpinner />} />;
}

export default AsyncBookingList;
